const tipUs = [    
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Patreon',
    title_text_color: '',
    link_value: '',    
    background_color: '',
    image_url: '',
    description: 'Become a',
    icon_group: 'podcasts', 
    icon_name: 'patreon',
    icon_color: 'black',
    placeholder: 'Patreon',
    value: "",
    name: "MAIN-BLOCK"
  },  
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Buy me a coffee',
    title_text_color: '',
    link_value: '',
    background_color: '',
    image_url: '',
    description: 'True Supporter',
    icon_group: 'podcasts', 
    icon_name: 'buy_me_a_coffee',
    icon_color: 'black',
    placeholder: 'Buy me a coffee',
    value: "",
    name: "MAIN-BLOCK"
  },  
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Ko-fi',
    title_text_color: '',
    link_value: '',
    background_color: '',
    image_url: '',
    description: 'Support us',
    icon_group: 'podcasts', 
    icon_name: 'kofi',
    icon_color: 'black',
    placeholder: 'https://ko-fi.com/',
    value: "",
    name: "MAIN-BLOCK"
  },    
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Square Cash',
    title_text_color: '',
    link_value: '',
    background_color: '',
    image_url: '',
    description: 'Support us',
    icon_group: 'podcasts', 
    icon_name: 'square_cash',
    icon_color: 'black',
    placeholder: 'https://squre.com/',
    value: "",
    name: "MAIN-BLOCK"
  }, 
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Venmo',
    title_text_color: '',
    link_value: '',
    background_color: '',
    image_url: '',
    description: 'Support us',
    icon_group: 'podcasts', 
    icon_name: 'venmo',
    icon_color: 'black',
    placeholder: 'https://venmo.com/',
    value: "",
    name: "MAIN-BLOCK"
  },     
  {
    main_type: 'TIP-US-BADGE',
    sortable: true,
    title: 'Paypal',
    title_text_color: '',
    link_value: '',
    background_color: '',
    image_url: '',
    description: 'Support us',
    icon_group: 'podcasts', 
    icon_name: 'paypal',
    icon_color: 'black',
    placeholder: 'https://paypal.com/',
    value: "",
    name: "MAIN-BLOCK"
  },           
]

export default tipUs;
